import React from 'react'

import { Slide } from '@material-ui/core'

const slide = ( settings = null ) => React.forwardRef( ( props , ref ) => <Slide ref={ref} { ...settings } {...props} /> ) ;

export default slide ;
